import React, { useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({ setAc, setTk, ac, tk, pid, setIsLoading }) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: true,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷已成功送出，感謝您的參與</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列
  // const visibleIfConditionsInit = {
  //   q25: "{q24} = ['none']",
  //   q34: "{q33} = ['none']",
  // }

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [14, 15]
  const notRequired = null

  // 尺規選項
  // const rateChoice = [
  //   { min: '(不是一個快樂的人)', max: '(是一個非常快樂的人)' },
  //   { min: '(比較不快樂)', max: '(比較快樂)' },
  //   { min: '(完全不能)', max: '(完全可以)' },
  //   { min: '(完全不能)', max: '(完全可以)' },
  // ]

  // const mappedRateChoice = rateChoice.map((v) => {
  //   return [
  //     {
  //       value: 1,
  //       text: '1 ' + v.min,
  //     },
  //     2,
  //     3,
  //     4,
  //     5,
  //     6,
  //     7,
  //     {
  //       value: 7,
  //       text: '7 ' + v.max,
  //     },
  //   ]
  // })
  // TODO: 改成幾階
  const mappedRateChoice = null
  // const pageBreakQuestions = ['q2', 'q11', 'q15']
  const pageBreakQuestions = null
  const triggersConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555
  }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
  })

  return (
    <>
      {convertedSurvey ? (
        <Survey model={newSurvey} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
